<template>
    <a-modal
        :id="modal.id"
        is-overlay-close
        type="screenshot"
        class="a-modal-acronis-demo"
    >
        <div v-if="hasRibbon" class="ribbon">
            <span v-if="ribbonTitle">{{ ribbonTitle }}</span>
            <a-link v-if="ribbonLink" v-bind="ribbonLink" />
            <a-button v-if="ribbonButton" v-bind="ribbonButton" />
        </div>
        <div class="iframe-container">
            <iframe
                :src="modal.src"
                :style="{ opacity: iframeReady ? 1 : 0, transition: 'opacity 0.3s ease' }"
                @load="iframeReady = true"
            />
        </div>
    </a-modal>
</template>

<script>
import AButton from '@core/components/button/button.vue';
import ALink from '@core/components/link/link.vue';
import AModal from '@core/components/modal/modal.vue';
import Modal from '@core/directives/modal.js';

export default {
    name: 'ADemoModal',

    components: {
        AButton,
        ALink,
        AModal,
    },
    directives: {
        Modal,
    },
    props: {
        modal: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            iframeReady: false,
        };
    },
    computed: {
        ribbon() {
            return this.modal.ribbon || {};
        },
        ribbonTitle() {
            return this.ribbon.title;
        },
        ribbonLink() {
            return this.ribbon.link;
        },
        ribbonButton() {
            return this.ribbon.button;
        },
        hasRibbon() {
            return this.ribbonTitle || this.ribbonLink || this.ribbonButton;
        },
    },
};
</script>

<style lang="postcss">
.a-modal-acronis-demo {
    .a-modal__wrapper {
        padding: 64px 0 8px !important;

        .overlay,
        .a-button {
            z-index: 1;
            min-width: unset!important;
        }

        .loader {
            .el-loading__content {
                .el-spinner {
                    border-color: #fff;
                }
                .mt-16 {
                    margin: 0;
                }
                .el-text {
                    display: none;
                }
            }
        }

        .a-modal__content {
            width: 98vw;
            max-width: 1440px;
            border-radius: 4px;
            overflow: auto;
        }

        .a-modal__inner {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }
    }
}
</style>

<style lang="postcss" scoped>
.ribbon {
    @mixin body-accent;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    background: var(--av-solid-brand-secondary-accent);
    color: var(--av-nav-primary);
    box-shadow: var(--av-shadow-small);
    border-bottom: 1px solid var(--av-brand-accent);
    text-align: center;
    position: sticky;
    top: 0;
    z-index: 90;
    padding: 12px 0;
}
.ribbon :deep(.a-button) .a-button__content {
    @mixin body-accent;
}
.iframe-container {
    z-index: 1;
    position: relative;
    width: 100%;
    height: calc(100vh - 117px); /* Deduct ribbon height and some padding */
    max-height: 750px;
    overflow: auto; /* Allow scrolling inside the container */
    display: flex;
    justify-content: center;
    align-items: flex-start; /* Align iframe to the top */
}
iframe {
    width: auto; /* Allow iframe content to determine its width */
    height: auto; /* Allow iframe content to determine its height */
    min-width: 100%;
    min-height: 100%;
    border: none;
}
</style>
